import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_SOURCE } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getClientSourceList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_SOURCE.GET_CLIENT_SOURCE_LIST}/${data?._Id}`
      : `${CLIENT_SOURCE.GET_CLIENT_SOURCE_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientSource = async (data = array()) => {
  try {
    const response = await POST(CLIENT_SOURCE.ADD_CLIENT_SOURCE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientSource = async (id, data = array()) => {
  try {
    const url = `${CLIENT_SOURCE.ADD_CLIENT_SOURCE}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientSourceDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${CLIENT_SOURCE.GET_CLIENT_SOURCE_LIST}/${data?.Id}`
      : `${CLIENT_SOURCE.GET_CLIENT_SOURCE_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientSourceTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_SOURCE.GET_CLIENT_SOURCE_SCHEMA}/${data?._Id}`
      : `${CLIENT_SOURCE.GET_CLIENT_SOURCE_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientSourceFilterData = async (data = array()) => {
  try {
    const response = await POST(CLIENT_SOURCE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
